<template>
	<div class="content">
		<div class="edubgc">
			<div class="edu">
				<img class="edu-img reveal-left" src="../assets/pomelo/part_03.png" alt="">
				<div class="edu-cont reveal-right">
					<h1>覆盖三端的互联网平台  <br>全面赋能幼教行业</h1>
					<img src="../assets/pomelo/part_04.png" alt="">
					<p>以儿童营养膳食为核心的幼儿园综合管理系统</p>
					<p>以幼师培训课程、信息化班级管理为核心的教师端应用</p>
					<p>以家园互动、家长学习为核心的家长端应用</p>
				</div>
			</div>
		</div>
		<div class="adv">
			<div class="conttitle">
				<h4 class="conttitle-title">行业痛点</h4>
				<img src="../assets/pomelo/title.png" alt="">
				<span class="conttitle-bor"></span>
			</div>
			<div class="cwidth">
				<ul class="adv-cont">
					<li class="reveal-bottom">
						<img src="../assets/pomelo/part_05a.png" alt="">
						<h4>教师面临</h4>
						<p>教师学历素质整体偏低，是幼教发展的最大瓶颈  <br>教师薪酬水平低，职业发展渠道受限<br>  与家长互相缺乏信任，沟通难度大</p>
					</li>
					<li class="reveal-bottom">
						<img src="../assets/pomelo/part_05b.png" alt="">
						<h4>园所面临</h4>
						<p>运营效率低下，保育压力大，信息化等手段应用不足<br>课程体系落后，小学化现象难以去除<br>民办幼儿园招生难，服务同质化，低质化</p>
					</li>
					<li class="reveal-bottom">
						<img src="../assets/pomelo/part_05c.png" alt="">
						<h4>家长面临</h4>
						<p>对幼儿教育质量的普遍焦虑<br>缺少专业科学育儿的指导<br>对幼儿的课外课选择的困扰</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="solve">
			<div class="solve-cont">
				<h4>KA解决方案</h4>
				<p>过去几年中，科技与资本在园所SaaS、家园共育、育儿内容、教师辅助等领域进行了诸多单点探索，<br>然而并未有效改变行业现状。当前行业最需要的是优质的系统性解决方案。</p>
				<p>为此，KA儿童之家推出了互联网三端产品柚子通，作为面向幼儿园所的互联网升级服务产品，旨在通过互联网链接幼儿园、教师、家长，并与线下培训服务相结合以提升幼儿园办园品质。产品主要包括以儿童营养膳食为核心的园所综合管理系统、以幼师培训课程以及信息化班级管理为核心的教师端应用、以家校互动以及家长学习为核心的家长端应用，线下服务部分主要包括园长培训、膳食培训、市场培训以及教师培训等。</p>
			</div>
		</div>
		<div class="intro">
			<div class="intro-gardent">
				<img src="../assets/pomelo/part_06a.png" alt=""  class="reveal-left">
				<div class="intro-gardent-cont reveal-right">
					<h3>园所端介绍</h3>
					<p>园所端是以儿童营养智能膳食管理系统为核心，通过园所端教师管理及家园沟通等智能工具让园所工作效率提升，解决及避免饮食安全，服药安全和出勤安全等问题，降低运营成本，轻松打造高品质的幼儿园。园所端系统包含创新出勤，报名招生，家园沟通，膳食管理，卫生保健5大体系模块。通过对幼儿出勤信息的管理，为教师智能生成出勤统计分析. GIS地图监测报名孩子的位置分布，精细化提高招生工作效率。围绕专业丰富的食谱库，通过人工智能算法输出智能食谱分析，并指导园所的配餐，采购，膳食管理等工作。在幼儿成长方面对体检体测形成报告及分析，对疫苗形成计划管理，使卫生保健工作规范化。在家园沟通层面，将园所食谱及家庭食谱规划，宝宝的出勤及请假记录，体检报告及健康指导呈现给家长。</p>
				</div>
			</div>
			<div class="intro-teacher">
				<img src="../assets/pomelo/part_06b.png" alt="" class="reveal-right">
				<div class="intro-teacher-cont reveal-left">
					<h3>教师端介绍</h3>
					<p>教师端是一个幼师专业成长平台，通过打造幼师开放平台为幼师提供训，研一体化的解决方案。教师端应用包含教师助手，成长培训，教学知识库，问答社区，儿童测评5大体系模块。专家，教师在平台中一起完成教材的共研共建，辅助教师教学及成长，并通过1000分钟，30个的精品课程全面立体的对教师提供培训指导，教师也可以通过录课系统实现人人为师的理念。专业的问答社区打造使不同层级的教师在社区中形成交流互动，完成知识库的基础沉淀，进一步强化了研训一体化的体系。用国内外优质测评体系和标准来观察评价孩子，让孩子的发展更加可视化。</p>
				</div>
			</div>
			<div class="intro-parent">
				<img src="../assets/pomelo/part_06c.png" alt="" class="reveal-left">
				<div class="intro-parent-cont reveal-right">
					<h3>家长端介绍</h3>
					<p>家长端是家长与园所之间沟通桥梁，通过集成园所管理系统，把家长面对面报告系统融入进家长繁忙的生活中去。家长端应用包含亲子时光，家长大学2大体系模块。将幼儿观察记录与评测结果，大咖微课，家园共育，课程专栏紧密结合在一起，采用结构化数据形式把家长大学，育儿经验，亲子时光等一系列内容相结合，增强家长与园所，家长与孩子之间的互动体验，帮助家长辅助孩子的成长。</p>
				</div>
			</div>
		</div>
		<div class="rightnow">
			<div class="rightnow-title">
				<h4>立即体验</h4>
				<p>咨询电话 </p>
			</div>
	        <div class="info">
	            <p class="info__tips">申请免费试用“柚子通”</p>
	            <ul class="info__form">
					<li class="info__form__sel">
					    <div class="mar">
							<region-picker
							:placeholder="{province: '请选择省份', city: '请选择城市', district: '请选择区/县'}"
							:province="region.province"
							:city="region.city"
							:district="region.district"
							@onchange="change">
						  </region-picker>
					        <!-- <select class="area province" name="province_code" id="province">
					             <option class="default_item" value="0">请输入省份</option>  
					        </select>
					        <select class="area city" name="city_code" id="city">
					             <option class="default_item" value="0">请输入城市</option>  
					        </select>
					        <select class="area county" name="county_code" id="county">
					             <option class="default_item" value="0">请输入区/县</option>  
					        </select> -->
					    </div>
					</li>
					<li class="info__form__gardent">
					    <label><img src="../assets/pomelo/rightnow_gardent.png" alt=""></label>
					    <input type="text" v-model="form.campusName" id="partner_name" name="campusName" placeholder="请输入园所名称">
					</li>
	                <li class="info__form__name">
	                    <label><img src="../assets/pomelo/rightnow_name.png" alt=""></label>
	                    <input type="text" v-model="form.customerName" id="partner_name" name="customerName" placeholder="请输入您的姓名">
	                </li>
	                <li class="info__form__phone">
	                    <label><img src="../assets/pomelo/rightnow_tel.png" alt=""></label>
	                    <input type="text" v-model="form.phone" id="partner_phone" name="phone" maxlength="11" placeholder="请输入您的电话">
	                </li>
	                <li class="info__form__submit">
	                    <a href="javascript:;" class="submit" @click="addCustomer">申请试用</a>
	                </li>
	            </ul>
	            <div class="info__img reveal-right">
	                <img src="../assets/pomelo/01.png" alt="">
	            </div>
	        </div>
		</div>
		<Confirm ref="confirm" :text="msg"></Confirm>
	</div>
</template>
<script>
import Vue from 'vue'
import RegionPicker from 'vue-region-picker'
import CHINA_REGION from 'china-area-data'
import scrollReveal from 'scrollreveal'
import axios from 'axios'
import { stringify } from 'qs'
import Confirm from './Common/Confirm'

Vue.use(RegionPicker, {
  region: CHINA_REGION,
  vueVersion: 2
})

export default {
	name: 'Pomelo',
	components: {
		Confirm
	},
	data () {
		return {
			region: {},
			form: {
				campusName: '',
				customerName: '',
				phone: '',
				type: this.$route.name,
				source: 1
			},
			province: '',
			city: '',
			district: '',
			scrollReveal: scrollReveal(),
			msg: ''
		}
	},
	methods: {
		change (value) {
			this.province = value.province
			this.city = value.city
			this.district = value.district
		},
		addCustomer () {
			let _this = this
			let params = {
				province: this.province,
				city: this.city,
				district: this.district,
				campusName: this.form.campusName,
				customerName: this.form.customerName,
				phone: this.form.phone,
				type: this.$route.name,
				source: 1
			}
			let phone = this.form.phone
			 if (!(/^1[34578]\d{9}$/.test(phone))) {
				  _this.msg = '请输入正确的手机号'
				  _this.$refs.confirm.show()
			 } else if (phone == '' || !phone) {
				 _this.msg = '请输入手机号'
				 _this.$refs.confirm.show()
		         
		      } else {
				axios.post('/api/customer/add',stringify(params))
				.then(function (response) {
					_this.msg = '申请试用成功'
					_this.$refs.confirm.show()
					//console.log(response);
				})
				.catch(function (error) {
					console.log(error);
				})
					//console.log(stringify(params))
		}

		}
	},
	mounted(){
		this.scrollReveal.reveal('.reveal-left', {
			duration: 1500,
			delay: 200,
			origin: 'left',
			reset: false,
			distance: '600px',
		});
		this.scrollReveal.reveal('.reveal-right', {
			duration: 1500,
			delay: 200,
			origin: 'right',
			reset: false,
			distance: '600px',
		});
		this.scrollReveal.reveal('.reveal-bottom', {
			duration: 1500,
			delay: 200,
			origin: 'bottom',
			reset: false,
			distance: '600px',
		});
	},
	
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../base/scss/mixin.scss';
.content {
	padding-top: 290px;
}
.headerbar {
	margin-bottom: 80px;
}
.edubgc {
	background: url(../assets/pomelo/part_02.png) no-repeat left center;
	margin-bottom: 90px;
}
.edu {
	// @extend %clearfix;
	@extend %width;
	height: 582px;
	position: relative;
	&-img {
		// float: left;
		width: 532px;
		position: absolute;
		left: 0;
		top: 0;
	}
	&-cont {
		margin-left: 532px - 32px;
		padding-top: 110px;
		h1 {
			margin-bottom: 10px;
			line-height: 74px;
			font-size: 48px;
			color: #1f4796;
		}
		img {
			display: block;
			margin-bottom: 14px;
		}
		p {
			margin-bottom: 10px;
			font-size: 16px;
			color: #111b3d;
		}
	}
}
.adv {
	height: 660px - 112px;
	padding-top: 112px;
	margin-bottom: 100px;
	background: url(../assets/pomelo/bg.jpg) center top no-repeat #f8f8f8;
	.conttitle {
		margin-bottom: 70px;
		&-title {
			margin-bottom: 6px;
		}
		&-bor {
			margin-top: 4px;
		}
	}
	&-cont {
		@extend %clearfix;
		margin-right: -40px;
		li {
			float: left;
			width: 350px - 2px;
			height: 300px - 40px - 2px;
			padding-top: 40px;
			background: #fff;
			border-radius: 4px;
			margin-right: 40px;
			text-align: center;
			transition: all ease-in .35s;
			border: 1px solid #fff;
			&:hover {
				border-color: #1d50a2;
				box-shadow: 0 0 46px rgba(220,219,219,.74);
			}
			img {
				margin-bottom: 36px;
			}
			h4 {
				margin-bottom: 32px - 7px;
				font-size: 18px;
				color: #091338;
			}
			p {
				line-height: 28px;
				font-size: 14px;
				color: #666;
			}
		}
	}
}
.solve {
	height: 400px - 110px;
	padding-top: 110px;
	margin-bottom: 152px;
	background: url(../assets/pomelo/solve_bg.jpg) center top no-repeat;
	&-cont {
		width: 924px - 55px - 55px;
		height: 232px - 32px;
		padding: 32px 55px 0;
		margin: 0 auto;
		background: url(../assets/pomelo/solve_box.png) left top no-repeat;
		text-align: center;
		color: #fff;
		h4 {
			margin-bottom: 15px;
			font-size: 20px;
		}
		p {
			line-height: 22px;
			font-size: 14px;
		}
	}
}
.intro {
	// padding-top: 152px;
	padding-bottom: 50px;
	margin-bottom: 134px;
	background: url(../assets/pomelo/part_09.png) right bottom no-repeat;
	h3 {
		padding-top: 24px;
		font-weight: normal;
		margin-bottom: 34px - 6px;
		font-size: 28px;
	}
	p {
		width: 520px;
		line-height: 24px;
		text-align: justify;
		font-size: 14px;
		color: #666;
	}
	&-gardent {
		img {
			float: left;
			margin-left: 22px;
		}
		&-cont {
			margin-left: 520px;
		}
	}
	&-gardent, 
	&-parent,
	&-teacher {
		@extend %width;
		@extend %clearfix;
		margin-bottom: 32px;
	}
	&-parent {
		img {
			float: left;
		}
		&-cont {
			margin-left: 450px + 47px;
		}
	}
	&-teacher {
		padding-top: 22px;
		h3 {
			padding-top: 146px;
		}
		img {
			float: right;
		}
		&-cont {
			// margin-right: 494px + 16px;
			margin-left: 86px;
		}
	}
	&-parent {
		h3 {
			padding-top: 155px;
		}
	}
}
.rightnow {
	margin-bottom: 250px;
	&-title {
		margin-bottom: 60px - 20px;
		text-align: center;
		color: #1d50a2;
		h4 {
			margin-bottom: 20px;
			font-weight: normal;
			font-size: 28px;
		}
		p {
			display: inline-block;
			padding-left: 30px;
			line-height: 20px;
			font-size: 16px;
			background: url(../assets/pomelo/tel.png) left center no-repeat;
		}
	}
	.info {
		position: relative;
		@include autoWidth();
		padding-top: 20px;
		&__tips {
			font-size: 20px;
			margin-bottom: 20px;
		}
		&__form {
			border-radius: 10px;
			background: url(../assets/pomelo/rightnow_bg.jpg) left top no-repeat;
			height: 490px - 54px;
			padding: 54px 0 0 100px;
			position: relative;
			li {
				position: relative;
				z-index: 2;
			}
			&__name,
			&__gardent{
				label {
					background: #1d50a2;
					
				}
			}
			&__phone {
				label {
					background: #e8374a;
				}
			}
			li {
				width: 490px;
				height: 60px;
				margin-bottom: 18px;
			}
			label,
			input {
				float: left;
			}
			label {
				height: 60px - 12px;
				width: 90px - 35px;
				padding-top: 12px;
				padding-left: 35px;
				border-radius: 4px;
			}
			input {
				width: 490px - 90px - 40px;
				padding: 0 20px;
				height: 60px;
				line-height: 60px;
				background: #F1F1F1;
				border-radius: 0 4px 4px 0;
				border: none;
				outline: 0;
				font-size: 16px;
				color: #999;
			}
			input,select {
				font-family: "黑体","SimHei";
			}
			&__sel {
				@include clearfix();
// 				.province,
// 				.city,
// 				.district {
// 					float: left;
// 					position: relative;
// 					height: 60px;
// 					padding: 18px 0 18px 6px;
// 					background: #F1F1F1;
// 					border-radius: 4px;
// 					margin-right: 16px;
// 					position: relative;
// 					border: none;
// 					font-size: 16px;
// 					color: #999;
// 					@at-root .form__drop {
// 						position: absolute;
// 						left: 0;
// 						top: 60px;
// 						background: #fff;
// 						width: 100%;
// 						display: none;
// 						li {
// 							padding-left: 20px;
// 							width: auto;
// 							text-overflow: ellipsis;
// 							white-space: nowrap;
// 							overflow: hidden;
// 							margin-bottom: 0;
// 							line-height: 35px;
// 							height: 35px;
// 							font-size: 14px;
// 							cursor: pointer;
// 							&:hover {
// 								background: #F1F1F1;
// 							}
// 						}
// 					}
// 				}
// 				.province {
// 					width: 117px;
// 				}
// 				.city,
// 				.district {
// 					width: 170px;
// 				}
			}
			&__submit {
				margin-top: 27px;
				.submit {
					width: 100%;
					height: 100%;
					line-height: 60px;
					background: #1d50a2;
					display: block;
					border-radius: 4px;
					text-align: center;
					font-size: 18px;
					color: #fff;
				}
			}
		}
		&__img {
			position: absolute;
			right: 96px;
			top: -20px;
		}
	}
}
.mar {
	margin-right: -16px;
}
</style>


// WEBPACK FOOTER //
// src/components/Pomelo.vue